export default "/_next/static/images/548a7fa2ec136dbd8703d50eab3c2c43.jpg";